import { createTheme } from '@mui/material/styles';

const grey = {
  50: 'hsla(0, 0%, 98%, 1)',
  100: 'hsla(0, 0%, 96%, 1)',
  200: 'hsla(0, 0%, 90%, 1)',
  300: 'hsla(0, 0%, 83%, 1)',
  400: 'hsla(0, 0%, 64%, 1)',
  500: 'hsla(0, 0%, 45%, 1)',
  600: 'hsla(0, 0%, 32%, 1)',
  700: 'hsla(0, 0%, 25%, 1)',
  800: 'hsla(0, 0%, 15%, 1)',
  900: 'hsla(0, 0%, 9%, 1)',
};

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      darker: 'hsla(37, 92%, 20%, 1)',
      dark: 'hsla(37, 92%, 50%, 1)',
      main: 'hsla(37, 96%, 59%, 1)',
      light: 'hsla(37, 97%, 88%, 1)',
      lighter: 'hsla(36, 100%, 96%, 1)',
    },
    secondary: {
      darker: 'hsla(0, 0%, 15%, 1)',
      dark: 'hsla(0, 0%, 32%, 1)',
      main: 'hsla(0, 0%, 64%, 1)',
      light: 'hsla(0, 0%, 90%, 1)',
      lighter: 'hsla(0, 0%, 96%, 1)',
    },
    error: {
      darker: 'hsla(0, 76%, 20%, 1)',
      dark: 'hsla(0, 77%, 40%, 1)',
      main: 'hsla(0, 76%, 48%, 1)',
      light: 'hsla(0, 76%, 90%, 1)',
      lighter: 'hsla(0, 75%, 97%, 1)',
    },
    warning: {
      darker: 'hsla(39, 100%, 20%, 1)',
      dark: 'hsla(39, 100%, 40%, 1)',
      main: 'hsla(39, 100%, 48%, 1)',
      light: 'hsla(39, 100%, 90%, 1)',
      lighter: 'hsla(40, 100%, 97%, 1)',
    },
    info: {
      darker: 'hsla(207, 86%, 20%, 1)',
      dark: 'hsla(207, 86%, 40%, 1)',
      main: 'hsla(207, 86%, 48%, 1)',
      light: 'hsla(207, 100%, 90%, 1)',
      lighter: 'hsla(208, 100%, 97%, 1)',
    },
    success: {
      darker: 'hsla(131, 53%, 20%, 1)',
      dark: 'hsla(131, 53%, 40%, 1)',
      main: 'hsla(131, 53%, 48%, 1)',
      light: 'hsla(131, 53%, 90%, 1)',
      lighter: 'hsla(135, 50%, 97%, 1)',
    },
    deepPurple: {
      darker: 'hsla(262, 52%, 20%, 1)',
      dark: 'hsla(262, 52%, 40%, 1)',
      main: 'hsla(262, 52%, 47%, 1)',
      light: 'hsla(262, 52%, 90%, 1)',
      lighter: 'hsla(266, 47%, 97%, 1)',
    },
    grey,
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[400],
    },
    background: {
      default: grey[50],
    },
    divider: grey[200],
  },
});

export enum ColorPalette {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
  DEEP_PURPLE = 'deepPurple',
}

export default theme.palette;
